import { useEffect, useState } from "react";
import { Search, SlidersHorizontal } from "lucide-react";
import { useSearchParams } from "react-router-dom";
import ProductCard from "../components/ProductCard";
import { db } from "../lib/data";
export default function ShopPage() {
  const [p, setP] = useSearchParams(),
    [q, setQ] = useState(p.get("q") || ""),
    [cat, setCat] = useState(p.get("category") || ""),
    [cats, setCats] = useState([]),
    [rows, setRows] = useState([]),
    [loading, setLoading] = useState(true);
  useEffect(() => {
    db.categories().then(setCats);
  }, []);
  useEffect(() => {
    setLoading(true);
    const t = setTimeout(
      () =>
        db
          .products({ q, category: cat, status: "active" })
          .then(setRows)
          .finally(() => setLoading(false)),
      200,
    );
    return () => clearTimeout(t);
  }, [q, cat]);
  const select = (v) => {
    setCat(v);
    const n = new URLSearchParams(p);
    v ? n.set("category", v) : n.delete("category");
    setP(n, { replace: true });
  };
  return (
    <section className="page shop-page">
      <div className="page-title">
        <span>Our Products</span>
        <h1>Shop</h1>
      </div>
      <div className="shop-toolbar">
        <div className="filters">
          <button className={!cat ? "active" : ""} onClick={() => select("")}>
            All
          </button>
          {cats.map((c) => (
            <button
              key={c.id}
              className={cat === c.id ? "active" : ""}
              onClick={() => select(c.id)}
            >
              {c.name}
            </button>
          ))}
        </div>
        <label className="shop-search">
          <Search size={16} />
          <input
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Search model, SKU or product"
          />
        </label>
      </div>
      <div className="shop-count">
        {loading ? "Loading…" : `${rows.length} products`}
      </div>
      <div className="shop-grid">
        {rows.map((x) => (
          <ProductCard key={x.id} product={x} />
        ))}
      </div>
      {!loading && !rows.length && (
        <div className="empty-state">
          <SlidersHorizontal />
          <p>No products match your search.</p>
        </div>
      )}
    </section>
  );
}
